import Footer from "../components/footer";
import Navbar from "../components/navbar";
import "../css/cpcs.css";

import { Helmet } from "react-helmet";
import crawlerCrane from "../images/a02-crawlercrane.png";
import industrialForklift from "../images/a16-industrialforklift.jpg";
import agriculturalTractor from "../images/a33-agriculturaltractor.webp";
import forwardTippingDumper from "../images/a09-forwardtippingdumper.png";
import liftingOperations from "../images/a61-liftingoperations.png";
import plantDriving from "../images/a68-plantdriving.jpg";
import towerCrane from "../images/a04-towercrane.png";
import plantMarshaller from "../images/a73-plantmarshaller.webp";
import excavator180Above5Tonnes from "../images/a12-excavator180above5tonnes.jpg";
import excavator180below5Tonnes from "../images/a10-excavator180below5tonnes.jpg";
import roughTerrainForklift from "../images/a14-roughterrainforklift.jpg";
import sideLoader from "../images/a15-sideloader.jpg";
import reachTruckForklift from "../images/a18-reachtruckforklift.jpg";
import grader from "../images/a19-grader.jpg";
import hoist from "../images/a20-hoist.webp";
import wheeledShovel from "../images/a21-wheeledshovel.jpg";
import trackedLoadingShovel from "../images/a22-trackedloadingshovel.jpg";
import skidSteerLoader from "../images/a23-skidsteerloader.jpg";
import motorisedScraper from "../images/a24-motorisedscraper.jpg";
import mewpScissor from "../images/a25-mewpscissor.jpg";
import mewpMasterClimber from "../images/a27-mewpmasterclimber.jpg";
import pilingRigTripod from "../images/a30-pilingrigtripod.jpg";
import crawlerTractorDozer from "../images/a34-crawlertractordozer.jpg";
import crawlerTractorSideBoom from "../images/a35-crawlertractorsideboom.jpg";
import trencher from "../images/a37-trencher.webp";
import skipHandler from "../images/a39-skiphandler.webp";
import slingerSignaller from "../images/a40-slingersignaller.webp";
import loaderCompressor from "../images/a41-loadercompressor.jpg";
import crusher from "../images/a42-crusher.webp";
import screener from "../images/a43-screener.jpg";
import trailerMountedConcretePump from "../images/a44-trailermountedconcretepump.jpg";
import pilingRigDrivenBelow20Tonnes from "../images/a45-pilingrigdrivenbelow20tonnes.jpg";
import pilingRigDrivenAbove20Tonnes from "../images/a46-pilingrigdrivenabove20tonnes.jpg";
import pilingRigDrivenBoredBelow20Tonnes from "../images/a47-pilingrigboredbelow20tonnes.jpg";
import loaderSecurer from "../images/a50-loadersecurer.jpg";
import telescopicHandler from "../images/a17-telescopichandler.png";
import rideOnRoller from "../images/a31-rideonroller.jpg";
import mewpBoom from "../images/a26-mewpboom.webp";
import dragline from "../images/a05-dragline.jpg";
import dumpTruckArticulated from "../images/a56-dumptruckarticulated.jpg";
import dumpTruckRigid from "../images/a57-dumptruckrigid.webp";
import excavator360Above10Tonnes from "../images/a59-excavator360above10tonnes.png";
import excavator360Below10Tonnes from "../images/a58-excavator360below10tonnes.jpg";
import mobileCrane from "../images/a60-mobilecrane.webp";
import compactCrane from "../images/a66-compactcrane.jpg";
import pilingRigAttendant from "../images/a74-pilingrigattendant.jpg";
import concretePlacingBoom from "../images/a72-concreteplacingboom.jpg";
import demolitionPlant from "../images/d90-demolitionplant.webp";
import skidSteerToolCarrier from "../images/d92-skidsteertoolcarrier.jpg";
import pilingRigBoredAbove20Tonnes from "../images/a48-pilingrigboredabove20tonnes.jpg";
import soilLandFillCompactor from "../images/a32-soillandfillcompactor.jpg";
import craneSupervisor from "../images/a62-cranesupervisor.png";
import overheadCrane from "../images/a64-overheadcrane.png";
import tunnellingLocomotives from "../images/a67-tunellinglocomotives.jpg";
import soilStabiliser from "../images/a71-soilstabiliser.jpg";
import conveyorPump from "../images/a75-conveyorpump.jpg";
import telescopicHandler360Slew from "../images/a77-telescopichandler360slew.jpg";
import vacuumExcavator from "../images/a78-vacuumexcavator.jpg";
import demolitionPlantPedestrianOperated from "../images/d91-demolitionplantpedestrianoperated.jpg";

const cpcsCategories = [
  {
    code: "A02",
    title: "Crawler Crane",
    image: crawlerCrane,
    link: "/cpcs-crawlercrane",
  },
  {
    code: "A16",
    title: "Industrial Forklift",
    image: industrialForklift,
    link: "/cpcs-industrialforklift",
  },
  {
    code: "A33",
    title: "Agricultural Tractor",
    image: agriculturalTractor,
    link: "/cpcs-agriculturaltractor",
  },
  {
    code: "A09",
    title: "Forward Tipping Dumper",
    image: forwardTippingDumper,
    link: "/cpcs-forwarddumper",
  },
  {
    code: "A61",
    title: "Lifting Operations",
    image: liftingOperations,
    link: "/cpcs-liftingoperations",
  },
  {
    code: "A68",
    title: "Plant Driving",
    image: plantDriving,
    link: "/cpcs-plantdriving",
  },
  {
    code: "A04",
    title: "Tower Crane",
    image: towerCrane,
    link: "/cpcs-towercrane",
  },
  {
    code: "A73",
    title: "Plant Marshaller",
    image: plantMarshaller,
    link: "/cpcs-plantmarshaller",
  },
  {
    code: "A12",
    title: "Excavator 180 Above 5T",
    image: excavator180Above5Tonnes,
    link: "/cpcs-excavatorabove5t",
  },
  {
    code: "A10",
    title: "Excavator 180 Below 5T",
    image: excavator180below5Tonnes,
    link: "/cpcs-excavatorbelow5t",
  },
  {
    code: "A14",
    title: "Rough Terrain Forklift",
    image: roughTerrainForklift,
    link: "/cpcs-roughterrainforklift",
  },
  {
    code: "A15",
    title: "Side Loader",
    image: sideLoader,
    link: "/cpcs-sideloader",
  },
  {
    code: "A18",
    title: "Reach Truck Forklift",
    image: reachTruckForklift,
    link: "/cpcs-reachtruck",
  },
  { code: "A19", title: "Grader", image: grader, link: "/cpcs-grader" },
  { code: "A20", title: "Hoist", image: hoist, link: "/cpcs-hoist" },
  {
    code: "A21",
    title: "Wheeled Shovel",
    image: wheeledShovel,
    link: "/cpcs-wheeledshovel",
  },
  {
    code: "A22",
    title: "Tracked Loading Shovel",
    image: trackedLoadingShovel,
    link: "/cpcs-trackedloadingshovel",
  },
  {
    code: "A23",
    title: "Skid Steer Loader",
    image: skidSteerLoader,
    link: "/cpcs-skidsteerloader",
  },
  {
    code: "A24",
    title: "Motorised Scraper",
    image: motorisedScraper,
    link: "/cpcs-motorisedscraper",
  },
  {
    code: "A25",
    title: "MEWP Scissor",
    image: mewpScissor,
    link: "/cpcs-mewpscissor",
  },
  {
    code: "A27",
    title: "MEWP Master Climber",
    image: mewpMasterClimber,
    link: "/cpcs-mewpmastclimber",
  },
  {
    code: "A30",
    title: "Piling Rig Tripod",
    image: pilingRigTripod,
    link: "/cpcs-pilingrigtripod",
  },
  {
    code: "A34",
    title: "Crawler Tractor / Dozer",
    image: crawlerTractorDozer,
    link: "/cpcs-crawlertractordozer",
  },
  {
    code: "A35",
    title: "Crawler Tractor Side Boom",
    image: crawlerTractorSideBoom,
    link: "/cpcs-crawlertractorsideboom",
  },
  { code: "A37", title: "Trencher", image: trencher, link: "/cpcs-trencher" },
  {
    code: "A39",
    title: "Skip Handler",
    image: skipHandler,
    link: "/cpcs-skiphandler",
  },
  {
    code: "A40",
    title: "Slinger Signaller",
    image: slingerSignaller,
    link: "/cpcs-slingersignaller",
  },
  {
    code: "A41",
    title: "Loader Compressor",
    image: loaderCompressor,
    link: "/cpcs-loadersignaller",
  },
  { code: "A42", title: "Crusher", image: crusher, link: "/cpcs-crusher" },
  { code: "A43", title: "Screener", image: screener, link: "/cpcs-screener" },
  {
    code: "A44",
    title: "Trailer Mounted Concrete Pump",
    image: trailerMountedConcretePump,
    link: "/cpcs-trailermountedpump",
  },
  {
    code: "A45",
    title: "Piling Rig Driven Below 20T",
    image: pilingRigDrivenBelow20Tonnes,
    link: "/cpcs-pilingrigdrivenbelow20t",
  },
  {
    code: "A46",
    title: "Piling Rig Driven Above 20T",
    image: pilingRigDrivenAbove20Tonnes,
    link: "/cpcs-pilingrigdrivenabove20t",
  },
  {
    code: "A47",
    title: "Piling Rig Bored Below 20T",
    image: pilingRigDrivenBoredBelow20Tonnes,
    link: "/cpcs-pilingrigboredbelow20t",
  },
  {
    code: "A49",
    title: "Loader Securer",
    image: loaderSecurer,
    link: "/cpcs-loadersecurer",
  },
  {
    code: "A17",
    title: "Telescopic Handler",
    image: telescopicHandler,
    link: "/cpcs-telescopichandler",
  },
  {
    code: "A31",
    title: "Ride-on Roller",
    image: rideOnRoller,
    link: "/cpcs-rideonroller",
  },
  { code: "A26", title: "MEWP Boom", image: mewpBoom, link: "/cpcs-mewpboom" },
  { code: "A05", title: "Dragline", image: dragline, link: "/cpcs-dragline" },
  {
    code: "A56",
    title: "Dump Truck Articulated",
    image: dumpTruckArticulated,
    link: "/cpcs-dumptruckarticulated",
  },
  {
    code: "A57",
    title: "Dump Truck Rigid",
    image: dumpTruckRigid,
    link: "/cpcs-dumptruckrigid",
  },
  {
    code: "A59",
    title: "Excavator 360 Above 10T",
    image: excavator360Below10Tonnes,
    link: "/cpcs-excavator360above10t",
  },
  {
    code: "A58",
    title: "Excavator 360 Below 10T",
    image: excavator360Above10Tonnes,
    link: "/cpcs-excavator360below10t",
  },
  {
    code: "A60",
    title: "Mobile Crane",
    image: mobileCrane,
    link: "/cpcs-mobilecrane",
  },
  {
    code: "A66",
    title: "Compact Crane",
    image: compactCrane,
    link: "/cpcs-compactcrane",
  },
  {
    code: "A74",
    title: "Piling Rig Attendant",
    image: pilingRigAttendant,
    link: "/cpcs-pilingrigattendant",
  },
  {
    code: "A72",
    title: "Concrete Placing Boom",
    image: concretePlacingBoom,
    link: "/cpcs-concreteplacingboom",
  },
  {
    code: "D90",
    title: "Demolition Plant",
    image: demolitionPlant,
    link: "/cpcs-demolitionplant",
  },
  {
    code: "D92",
    title: "Skid Steer Tool Carrier",
    image: skidSteerToolCarrier,
    link: "/cpcs-skidsteertoolcarrier",
  },
  {
    code: "A48",
    title: "Piling Rig Bored Above 20T",
    image: pilingRigBoredAbove20Tonnes,
    link: "/cpcs-pilingrigboredabove20t",
  },
  {
    code: "A32",
    title: "Soil Landfill Compactor",
    image: soilLandFillCompactor,
    link: "/cpcs-soillandfillcompactor",
  },
  {
    code: "A62",
    title: "Crane Supervisor",
    image: craneSupervisor,
    link: "/cpcs-cranesupervisor",
  },
  {
    code: "A64",
    title: "Overhead Crane",
    image: overheadCrane,
    link: "/cpcs-overheadcrane",
  },
  {
    code: "A67",
    title: "Tunnelling Locomotives",
    image: tunnellingLocomotives,
    link: "/cpcs-tunellinglocomotives",
  },
  {
    code: "A71",
    title: "Soil Stabiliser",
    image: soilStabiliser,
    link: "/cpcs-soilstabiliser",
  },
  {
    code: "A75",
    title: "Conveyor Pump",
    image: conveyorPump,
    link: "/cpcs-conveyorpump",
  },
  {
    code: "A77",
    title: "Telescopic Handler 360 Slew",
    image: telescopicHandler360Slew,
    link: "/cpcs-telescopichandler360slew",
  },
  {
    code: "A78",
    title: "Vacuum Excavator",
    image: vacuumExcavator,
    link: "/cpcs-vacuumexcavator",
  },
  {
    code: "D91",
    title: "Demolition Plant Pedestrian Operated",
    image: demolitionPlantPedestrianOperated,
    link: "/cpcs-demolitionplantpedestrianoperated",
  },
];

export default function Cpcs() {
  return (
    <>
      <Helmet>
        <title>CPCS | Alpha Construction Training</title>
        <meta
          name="description"
          content="Explore CPCS training at Alpha Construction Training. Learn about requirements, assessments, and machinery categories for plant operators across the UK."
        />
        <link rel="canonical" href="https://www.alphacontraining.co.uk/cpcs" />
      </Helmet>
      <Footer />
      <Navbar />
      <div className="cpcs-container">
        <header className="cpcs-header">
          <h2>Professional CPCS Categories</h2>
        </header>

        <div className="cpcs-grid">
          {cpcsCategories.map((item) => (
            <div
              key={item.code}
              className="cpcs-card"
              onClick={() => (window.location.href = item.link)}
            >
              <div className="image-wrapper">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="card-content">
                <span className="category-code">{item.code}</span>
                <h3 className="category-title">{item.title}</h3>
                <div className="view-link">View Course Details →</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
